import styled from 'styled-components';
import { brandColors } from '../../constants/styles';

const Divider = styled.div`
  width: 100%;
  height: 0;
  border: solid 1px ${brandColors.gray400};
`;

export default Divider;
